const isDataEmpty = <D,>(data: D) => data == null;
/**
 * Wraps a hook to support React Suspense by leveraging loading and data states. This enhancement allows a component to suspend rendering until the necessary data is loaded, thereby improving the user experience in asynchronous operations.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withSuspense<T extends (...args: any[]) => any>(theHook: T) {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return ((...args: Parameters<T>) => {
		const result = theHook(...args);
		if (!__SERVER__ && isDataEmpty(result.data) && result.loading) {
			throw result.promise;
		}
		return result;
	}) as T;
}
